export const BREAKPOINTS = {
  sm: 320,
  tb: 768,
  md: 1024,
  lp: 1280,
  xl: 1600,
};

export default {
  data() {
    return {
      isMobile: true,
    };
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    isScreenMobile() {
      return window.innerWidth <= BREAKPOINTS.tb;
    },
    onWindowResize() {
      this.isMobile = this.isScreenMobile();
    },
  },
};
